import { useEffect } from 'react';
import Menu from '../../../commons/Menu/Menu';

export default () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Menu />
      <div style={{ padding: 8 }}>
        <p style={{ whiteSpace: 'pre-line' }}>
          CGV Publiconsult <br />
          Identité du vendeur : <br />
          SAS LENS GROUP- inscrite au RCS de Perpignan 847 550 910 – N° SIRET 84755091000024 – N° de
          TVA FR84847550910 <br />
          Clause n° 1 : Objet et champ d'application <br />
          Les présentes conditions générales de vente (CGV) constituent le socle de la négociation
          commerciale et sont systématiquement adressées ou remises à chaque acheteur pour lui
          permettre de passer commande. Les conditions générales de vente décrites ci-après
          détaillent les droits et obligations de Lens Group et de son client dans le cadre de la
          vente du service suivant : Publiconsult. <br />
          Toute acceptation du devis/bon de commande en ce compris la clause « Je reconnais avoir
          pris connaissance et j'accepte les conditions générales de vente ci-annexées » implique
          l'adhésion sans réserve de l'acheteur aux présentes conditions générales de vente. <br />
          Clause n°2 Prix : <br />
          Les prix du service vendu sont ceux en vigueur au jour de la prise de commande. Ils sont
          libellés en euros et calculés hors taxes. Par voie de conséquence, ils seront majorés du
          taux de TVA applicable au jour de la commande. <br />
          Lens Group s'accorde le droit de modifier ses tarifs à tout moment. Toutefois, elle
          s'engage à facturer les services commandés aux prix indiqués lors de l'enregistrement de
          la commande. <br />
          Les acheteurs publics peuvent souscrire à une option payante lors de leur dépôt de
          consultation. <br />
          Clause n°3 Précommandes et pré-inscription <br />
          Sur la partie s’étalant du 17/07/2023 au 01/09/2023, seulement des précommandes avec
          paiement immédiat seront possibles. <br />
          Sur la partie s’étalant du 17/07/2023 au 01/09/2023, les acheteurs publics pourront
          s’inscrivent sur Publiconsult mais ne pourront pas réaliser de demande de consultation.{' '}
          <br />
          Clause n° 4 Conditions de règlements et pénalités de retard <br />
          Le règlement de l’abonnement annuel de Publiconsult est effectué en ligne sur un site
          protégé (https://) par carte bancaire ou par Paypal. <br />
          Lorsqu’un acheteur public à souscrit à une option payante, le paiement de cette option se
          fera sous 30 jours calendaire après le dépôt de la facture correspondant à cette option
          sur la plateforme Chorus. <br />
          Tout retard de paiement fera l’objet de pénalités. La pénalité de retard sera basée sur le
          taux d'intérêt taux directeur de la Banque centrale européenne (BCE), en vigueur au 1er
          janvier ou au 1er juillet, majoré de 10 points. Cette pénalité est calculée sur le montant
          TTC de la somme restant due, et court à compter de la date d'échéance du prix sans
          qu'aucune mise en demeure préalable ne soit nécessaire. <br />
          En sus des indemnités de retard, toute somme, y compris l’acompte, non payée à sa date
          d’exigibilité produira de plein droit le paiement d’une indemnité forfaitaire de 40 euros
          due au titre des frais de recouvrement (Articles 441-10 et D. 441-5 du code de commerce).{' '}
          <br />
          Clause n°5 : Exécution des services : <br />
          Suite à son inscription en ligne et son paiement, le Client reçoit un mail d’activation de
          sa demande. <br />
          Son apparition dans l’annuaire en tant qu’entreprise est réalisée sous 48h maximum. <br />
          La réception d’offres de la part des acheteurs public sera active sous 48h maximum. <br />
          L’offre Publiconsult est activée pour une durée de 365 jour calendaire à compter du
          paiement de la commande. Passé ce délai, le Client devra procéder à une nouvelle commande
          pour réactiver son offre. Le Client n’est pas réengagé automatiquement. <br />
          Clause n°6 Garantie et SAV : <br />
          Pour toute demande sur l’utilisation du service, le Client contacte directement par email
          contact@publiconsult.fr <br />
          Clause n°7 : Suppression du service <br />
          Le service pourra être supprimé à tout moment, sans préavis et sans remboursement possible
          dans les cas suivants : <br />- Passage de l’entreprise du Client en liquidation
          judiciaire ou fermeture de la société <br />
          - Non-respect de la catégorie sélectionnée en fonction du nombre de salariés dans
          l’entreprise au moment de l’inscription <br />
          Clause n°8 Remboursement et délai de rétractation : <br />
          Le délai de rétractation court à partir de 14 jours calendaires à compter du paiement de
          la vente Publiconsult. <br />
          Modalités de Remboursement : <br />
          Tout client souhaitant se rétracter après avoir conclus et payé la vente de Publiconsult
          doit rédiger le formulaire type de rétractation et l’envoyer par voie postale au siège de
          Lens Group ou par email à l’adresse mail suivante contact@publiconsult.fr: <br />
          Je soussigné (e), Madame /Monsieur Nom Prénom…………………………………………………………………., représentant de
          la société Nom de la Société…………………………………………………………………………… demande à me rétracter suite à
          la vente de votre produit Publiconsult. <br />
          Cette vente a eu lieu le DATE (JJ/MM/AAAA)…………………………………………………………………………. <br />
          Merci de bien vouloir procéder au remboursement du montant TTC suivant : …………………..€ <br />
          Sur le compte bancaire suivant : <br />
          Nom du compte bancaire : <br />
          IBAN ………………… <br />
          BIC ……………. <br />
          Afin d’améliorer la rapidité du traitement de ma demande de remboursement, j’autorise Lens
          Group à me contacter par téléphone XX.XX.XX.XX. XX ou par email
          ……………………………………….@................ <br />
          <br />
          Lens Group procède sous 14 jours au remboursement de la totalité des sommes versées par le
          Client après avoir pris notification de la demande. <br />
          Clause n° 9 : Force majeure <br />
          La responsabilité de Lens Group ne pourra pas être mise en œuvre si la non-exécution ou le
          retard dans l'exécution de l'une de ses obligations décrites dans les présentes conditions
          générales de vente découle d'un cas de force majeure. À ce titre, la force majeure
          s'entend de tout événement extérieur, imprévisible et irrésistible au sens de l'article
          1148 du Code civil. <br />
          Clause n° 10 : Litiges <br />
          Le Client a la possibilité de faire appel à un médiateur de la consommation. <br />
          Tout litige relatif à l'interprétation et à l'exécution des présentes conditions générales
          de vente est soumis au droit français. <br />À défaut de résolution amiable, le litige
          sera porté devant le Tribunal de commerce de Perpignan.
        </p>
      </div>
    </>
  );
};
